var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDpcWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1805",
    "data-name": "Group 1805",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1805-2",
    "data-name": "Group 1805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M15.364,2.636A9,9,0,1,0,2.636,15.364,9,9,0,1,0,15.364,2.636ZM3.383,3.383A7.925,7.925,0,0,1,6.116,1.594a7.42,7.42,0,0,0-.753,1.159,10.368,10.368,0,0,0-.693,1.654A16.258,16.258,0,0,1,2.827,4,8.1,8.1,0,0,1,3.383,3.383ZM2.188,4.907a16.307,16.307,0,0,0,2.2.521,15.323,15.323,0,0,0-.389,3.044H1.074A7.873,7.873,0,0,1,2.188,4.907ZM2.13,13A7.874,7.874,0,0,1,1.073,9.528H4a15.308,15.308,0,0,0,.382,2.96A17.112,17.112,0,0,0,2.13,13Zm1.252,1.622a8.083,8.083,0,0,1-.627-.705,17.07,17.07,0,0,1,1.906-.4,10.386,10.386,0,0,0,.7,1.676,7.3,7.3,0,0,0,.827,1.248A7.923,7.923,0,0,1,3.383,14.617Zm5.09,2.191a3.935,3.935,0,0,1-2.177-2.118,9.18,9.18,0,0,1-.568-1.321c.869-.1,1.795-.152,2.745-.166Zm0-4.661a29.747,29.747,0,0,0-3.044.194,14.161,14.161,0,0,1-.375-2.813H8.472v2.62Zm0-3.676H5.051a14.182,14.182,0,0,1,.381-2.89A29.313,29.313,0,0,0,8.472,5.8Zm0-3.733c-.954-.019-1.877-.081-2.741-.183a9.179,9.179,0,0,1,.563-1.308A3.935,3.935,0,0,1,8.472,1.13Zm7.373.224a7.875,7.875,0,0,1,1.081,3.509H14.005a15.343,15.343,0,0,0-.381-3.011A17.243,17.243,0,0,0,15.846,4.963ZM14.617,3.383a8.09,8.09,0,0,1,.595.665,17.233,17.233,0,0,1-1.87.391,10.393,10.393,0,0,0-.7-1.685,7.42,7.42,0,0,0-.753-1.159A7.925,7.925,0,0,1,14.617,3.383ZM9.528,9.528h3.419a14.143,14.143,0,0,1-.38,2.834,29.341,29.341,0,0,0-3.039-.211Zm0-1.056V5.8a29.779,29.779,0,0,0,3.047-.192,14.2,14.2,0,0,1,.375,2.865H9.528Zm0-7.342h0a3.935,3.935,0,0,1,2.177,2.118,9.193,9.193,0,0,1,.571,1.331c-.871.1-1.8.151-2.748.164Zm0,15.679v-3.6c.953.019,1.876.08,2.739.181a9.173,9.173,0,0,1-.561,1.3A3.935,3.935,0,0,1,9.528,16.809Zm5.089-2.191a7.921,7.921,0,0,1-2.806,1.817,7.3,7.3,0,0,0,.827-1.248,10.364,10.364,0,0,0,.692-1.649,16.242,16.242,0,0,1,1.881.417A8.1,8.1,0,0,1,14.617,14.617Zm1.224-1.574a16.307,16.307,0,0,0-2.226-.528A15.3,15.3,0,0,0,14,9.528h2.923A7.875,7.875,0,0,1,15.842,13.043Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpcWebsite);
export default __webpack_public_path__ + "static/media/dpcWebsite.6436904b2b66414b006d925223bc5d45.svg";
export { ForwardRef as ReactComponent };